/**
|--------------------------------------------------
| @vunv

|--------------------------------------------------
*/
export const redirect_page = (url) => {
	window.location.assign(url)
}